export default __webpack_public_path__ + "static/media/logo.3389a739.svg";